import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { DcrModule } from '@ddt-web/dcr';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { TableCellModule } from '../table-cell';
import { CombinedDataTableComponent } from './combined-data-table.component';

@NgModule({
	declarations: [CombinedDataTableComponent],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		TableCellModule,
		DcrModule,
		GenericDirectivesModule,
		DomModule
	],
	exports: [CombinedDataTableComponent]
})
export class CombinedDataTableModule { }
